import React from "react";
import WorkIcon from "@mui/icons-material/Work";
import FormValidation from "../../components/FormValidation/FormValidation";
import formFields from "../../config/formFields.json";

const AddResourceSkill = ({
  open,
  onClose,
  initialData = null,
  onSubmit,
  resources = [],
  skills = [],
}) => {
  const isEdit = !!initialData;

  const initialValues = {
    resource_id: initialData?.resource_id?.toString() || "",
    skill_id: initialData?.skill_id?.toString() || "",
    year_of_experience: initialData?.year_of_experience || "",
    proficient_level_enum: initialData?.proficient_level_enum || "",
    is_active: initialData?.is_active ?? true,
  };
  console.log("initialValues", initialValues);

  const getOptionsForField = (source) => {
    switch (source) {
      case "Resource":
        return resources.map((resource) => ({
          value: resource.resource_id.toString(),
          label: resource.first_name,
        }));
      case "Skill":
        return skills.map((skill) => ({
          value: skill.skill_id.toString(),
          label: skill.skill_name,
        }));
      default:
        return [];
    }
  };
  return (
    <FormValidation
      open={open}
      onClose={onClose}
      initialData={initialValues}
      onSubmit={onSubmit}
      formFields={formFields.resourceSkillMapping.basic.fields}
      title={isEdit ? "Edit Resource Skill" : "Add Resource Skill"}
      icon={WorkIcon}
      getOptionsForField={getOptionsForField}
      isEdit={isEdit}
      modelWidth="md"
    />
  );
};

export default AddResourceSkill;
